import React, { Component } from 'react'
import styles from './container.scss'

class Container extends Component {
  render() {
    return (
      <div className={styles['c-container']}>
        {this.props.children}
      </div>
    )
  }
}

export default Container
